import { TorchCaptureCopy } from './torch-capture-copy';
import { TorchCaptureState, TorchCaptureStatus } from './torch-capture.model';
import { isZoomed, zoomLabel } from './torch-zoom';

export interface TorchToggleVm {
  readonly label: string;
  readonly icon: 'flashlight_on' | 'flashlight_off';
  readonly pressed: boolean;
  readonly disabled: boolean;
}

export interface TorchCaptureVm {
  readonly busyMessage: string | null;
  readonly cancelLabel: string;
  readonly shutterLabel: string;
  readonly shutterDisabled: boolean;
  readonly torch: TorchToggleVm | null;
  readonly zoomLabel: string | null;
  readonly previewScale: number;
}

export function buildTorchCaptureVm(state: TorchCaptureState, copy: TorchCaptureCopy): TorchCaptureVm {
  const locked = state.status !== 'live';
  return {
    busyMessage: busyMessageFor(state.status, copy),
    cancelLabel: copy.cancel,
    shutterLabel: copy.shutter,
    shutterDisabled: locked,
    torch: state.torchAvailable
      ? {
          label: state.torchOn ? copy.torchOff : copy.torchOn,
          icon: state.torchOn ? 'flashlight_off' : 'flashlight_on',
          pressed: state.torchOn,
          disabled: locked
        }
      : null,
    zoomLabel: isZoomed(state.zoom, state.zoomRange) ? zoomLabel(state.zoom) : null,
    previewScale: state.zoomMode === 'digital' ? state.zoom : 1
  };
}

function busyMessageFor(status: TorchCaptureStatus, copy: TorchCaptureCopy): string | null {
  const messages: Partial<Record<TorchCaptureStatus, string>> = {
    starting: copy.starting,
    preparing: copy.turningLightOn,
    capturing: copy.capturing
  };
  return messages[status] ?? null;
}
